/** Money is stored as integer paise everywhere; format only at the edge. */
export function formatINR(paise, { decimals = 0 } = {}) {
  if (paise == null || paise === '') return '—';
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(Number(paise) / 100);
}

export function formatDate(value) {
  if (!value) return '—';
  return new Date(value).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
}

/** Axios error → readable message. */
export function errorText(ex) {
  return (ex && ex.response && ex.response.data && ex.response.data.error) || (ex && ex.message) || 'Something went wrong';
}
